const GraphTypes = {
    LINE : 'LINE',
    BAR : 'BAR',
    PIE : 'PIE',
    DOUGHNUT : 'DOUGHNUT',
    CALLOUT : 'CALLOUT',
    POLAR : 'POLAR',
    RADAR : 'RADAR',
}


export default GraphTypes